<template>
  <el-form
    status-icon
    label-position="left"
    ref="form"
    :model="form"
    :rules="rules"
  >
    <el-form-item label="密码" prop="pass">
      <el-input
        type="password"
        autocomplete="off"
        placeholder="请输入密码"
        v-model="form.pass"
        @input="antiShake"
      ></el-input
    ></el-form-item>
    <el-form-item label="确认密码" prop="checkPass">
      <el-input
        type="password"
        autocomplete="off"
        placeholder="请再次输入密码"
        v-model="form.checkPass"
        @input="antiShake"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import eventBus from "@/utils/eventBus.js";
import antiShake from "@/utils/antiShake.js";
import { password } from "@/utils/regexp.js";
export default {
  created() {
    eventBus.$on("password-Reset", this.reset);
    this.antiShake = antiShake(() => {
      this.$refs["form"].validate((valid) => {
        eventBus.$emit("password-Change", valid ? this.form : null);
      });
    }, 500);
  },
  destroyed() {
    eventBus.$off("password-Reset", this.reset);
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (!password.test(value)) {
          callback(new Error("密码至少6位且不能包含空格"));
        }
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "change" }],
        checkPass: [{ validator: validatePass2, trigger: "change" }],
      },
    };
  },
  methods: {
    reset() {
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style></style>
